import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreInput,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { handleErrors } from '@/Shared/ui/form'
import { PasswordChangeDataForm } from '@/User/domain'
import { createApiUserRepository } from '@/User/infrastructure'
import { useChangePassword } from '@/User/ui/hooks'
import { passwordChangerTranslation } from '@/User/ui/userTranslation'

export const PasswordChanger = (): JSX.Element => {
  const { t } = useTranslation()

  const {
    form: { register, formState, handleSubmit },
    save,
  } = useChangePassword(createApiUserRepository())
  const { dirtyFields } = formState

  const { errors } = handleErrors(formState)

  const handlePasswordChange = async (data: PasswordChangeDataForm): Promise<void> => {
    await save(data)
  }

  return (
    <OreCardContainer>
      <OreCardWrapper space="large">
        <form data-testid="passwordForm">
          <OreHeading size="headline-sm" as="h2">
            {t(passwordChangerTranslation.title)}
          </OreHeading>
          <OreDivider space="medium" />
          <OreStack placeContent="stretch" space="large">
            <OreText>{t(passwordChangerTranslation.subtitle)}</OreText>
            <OreInput
              {...register('oldPassword')}
              {...errors('oldPassword')}
              id="current_password"
              type="password"
              label={t(passwordChangerTranslation.currentPassword.label)}
              required
            />
            <OreInput
              {...register('newPassword')}
              {...errors('newPassword')}
              id="new_password"
              type="password"
              label={t(passwordChangerTranslation.newPassword.label)}
              legend={t(passwordChangerTranslation.newPassword.legend)}
              required
            />
            <OreInput
              {...register('newPasswordRepeat')}
              {...errors('newPasswordRepeat')}
              id="repeat_password"
              type="password"
              label={t(passwordChangerTranslation.repeatPassword.label)}
              required
            />
            <OreStack>
              <OreButton
                category="primary"
                onClick={handleSubmit(handlePasswordChange)}
                type="submit"
                disabled={
                  !dirtyFields.oldPassword ||
                  !dirtyFields.newPassword ||
                  !dirtyFields.newPasswordRepeat
                }
                data-testid="savePassword"
              >
                {t(passwordChangerTranslation.submit)}
              </OreButton>
            </OreStack>
          </OreStack>
        </form>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
